import React, { Fragment, useState, useEffect, useContext } from "react";
import classes from "../Table/Table.module.css";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import { Link } from "react-router-dom";
import GlobalContext from "../../providers/GlobalProvider";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";

export default function Currency() {
  const { defaultMapper } = useContext(GlobalContext);
  const [tblCurrencyMatching, setTblCurrencyMatching] = useState([]);
  const [newEntry, setNewEntry] = useState({
    selectedOps: "",
    selectedAccounting: null,
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [matches, setMatches] = useState([]);
  const [filteredArrays, setFilteredArrays] = useState({
    ops: [],
    accounting: [],
  });

  const getCurrency = async () => {
    let url = "/api/Currency";

    await axios
      .get(url)
      .then((result) => {
        setFilteredArrays({
          ops: result.data.currencies,
          accounting: result.data.accounting,
        });
        setTblCurrencyMatching(result.data.currMatchings);
        refreshMatching();
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  };

  const getDisplay = (matching) => {
    let foundOps, foundAccounting;
    foundOps = filteredArrays.ops.find(
      (obj) =>
        obj["id"].toUpperCase() == matching["opsCurrencyId"].toUpperCase()
    );
    foundAccounting = filteredArrays.accounting.find(
      (obj) => obj["code"] == +matching["codeCurrIds"]
    );
    return {
      ...matching,
      __ops: matching.__ops || foundOps,
      __accounting: matching.__accounting || foundAccounting,
    };
  };

  const refreshMatching = () => {
    const updatedMatches = tblCurrencyMatching.map(getDisplay);
    setMatches(updatedMatches);
  };
  const handleSaveClick = async () => {
    let url = "/api/Currency";
    const MatchingItem = {
      ["opsCurrencyId"]: newEntry.selectedOps,
      ["codeCurrIds"]: +newEntry.selectedAccounting,
    };
    if (MatchingItem) {
      // Update matches state with newMatch
      const updatedTblCurrencyMatching = [...tblCurrencyMatching, MatchingItem];
      setTblCurrencyMatching(updatedTblCurrencyMatching);

      // Reset the form
      setNewEntry({
        selectedOps: "",
        selectedAccounting: "",
      });
    }
    try {
      const result = await axios.post(url, MatchingItem);
      setSuccess("Data saved successfully!");
      setError("");
      // return result.data;
    } catch (error) {
      if (error.response && error.response.status === 409) {
        setError(error.response.data + "");
        setSuccess("");
      } else {
        setError("Error saving data.");
        setSuccess("");
      }
      console.error(
        "Error saving data:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const handleDeleteClick = async (matching) => {
    let url = `/api/Currency/${matching.opsCurrencyId}`;
    await axios
      .delete(url)
      .then((response) => {
        setTimeout(() => {
          setSuccess("Data Deleted Successfully!");
        }, 1000);
        setError("");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((error) => {
        console.error("Error deleting item:", error);
      });
    await getCurrency();
  };

  const handleOpsSelectChange = (event) => {
    const selectedId = event.target.value;
    let found =
      selectedId &&
      filteredArrays.ops.find((item) => `${item["id"]}` == selectedId);
    if (found) {
      newEntry.selectedOps = selectedId;
    } else {
      newEntry.selectedOps = undefined;
    }

    setNewEntry({
      ...newEntry,
    });
  };

  const handleAccountingSelectChange = (event) => {
    const selectedId = event.target.value;
    let found = filteredArrays.accounting.find(
      (item) => `${item["code"]}` === selectedId
    );
    if (found) {
      setNewEntry({ ...newEntry, selectedAccounting: selectedId });
    } else {
      setNewEntry({ ...newEntry, selectedAccounting: undefined });
    }
  };

  useEffect(() => {
    refreshMatching();
  }, [tblCurrencyMatching, filteredArrays]);

  useEffect(() => {
    getCurrency();
  }, [defaultMapper]);

  if (loading) {
    return (
      <div>
        <ClipLoader
          loading={loading}
          size={100}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }
  return (
    <>
      <Table hover bordered="false" responsive="sm" order>
        <thead>
          <tr>
            <th>Ops</th>
            <th>Accounting</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {matches && matches.length > 0 ? (
            matches.map((matching) => {
              const foundOpsName = matching.__ops;
              const foundAccountingName = matching.__accounting;

              return (
                <tr
                  key={foundOpsName["name"] + foundAccountingName.description}
                >
                  <td>{foundOpsName ? foundOpsName["name"] : "N/A"}</td>
                  <td>
                    {foundAccountingName
                      ? foundAccountingName["description"]
                      : "N/A"}
                  </td>
                  <td className={classes.delete}>
                    <Button
                      variant="outline-danger"
                      onClick={() => handleDeleteClick(matching)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="2">No matches found</td>
            </tr>
          )}

          <tr>
            <td>
              <div>
                <select
                  onChange={handleOpsSelectChange}
                  name="selectedOps"
                  value={newEntry.selectedOps}
                  // disabled={disabled}
                >
                  <option value="">Select an option</option>
                  {filteredArrays.ops.map((item) => (
                    <option key={item["id"]} value={item["id"]}>
                      {item["name"]}
                    </option>
                  ))}
                </select>
              </div>
            </td>
            <td>
              <div>
                <select
                  name="selectedAccounting"
                  value={newEntry.selectedAccounting}
                  onChange={handleAccountingSelectChange}
                  // disabled={disabledMain}
                >
                  <option value="">Select an option</option>
                  {filteredArrays.accounting.map((option) => (
                    <option key={option["code"]} value={option["code"]}>
                      {option["description"]}
                    </option>
                  ))}
                </select>
              </div>
            </td>
            <td></td>
          </tr>
        </tbody>
      </Table>

      <Link to="/">
        <Button variant="outline-danger">Main Menu</Button>
      </Link>
      <Button
        variant="outline-success"
        onClick={handleSaveClick}
        // disabled={disableSave}
      >
        Save
      </Button>
      <h5 style={{ color: "red" }}>{error}</h5>
      <h5 style={{ color: "green" }}>{success}</h5>
    </>
  );
}
